export default __webpack_public_path__ + "static/media/fast-pass-logo.e90ceac1.jpg";